import React, { useState } from 'react';
import { db } from '../config/firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { serverTimestamp } from 'firebase/firestore';


const BlogEkle = () => {
  const [baslik, setBaslik] = useState('');
  const [aciklama, setAciklama] = useState('');
  const [icerik, setIcerik] = useState('');
  const [kategori, setKategori] = useState('Yabancı Dil');
  const [gorsel, setGorsel] = useState(null);
  const [gorselUrl, setGorselUrl] = useState('');
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const kategoriler = [
    'Yabancı Dil',
    'Web Tasarım',
    'Yazılım',
    'Kişisel Gelişim',
    'Teknoloji',
  ];

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      ['clean'],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
    ],
  };

  // Cloudinary ile görsel yükleme
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      setHata('Lütfen bir dosya seçin.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'blog_upload'); // Oluşturduğunuz unsigned upload preset
    formData.append('api_key', '771442818997162'); // Cloudinary API Key

    setYukleniyor(true);
    try {
      const response = await axios.post(
        'https://api.cloudinary.com/v1_1/untitled/image/upload', // Cloud Name: "untitled"
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 15000, // 15 saniye timeout
        }
      );

      setGorselUrl(response.data.secure_url);
      setGorsel(file);
      setBasari('Görsel başarıyla yüklendi!');
      setHata('');
    } catch (error) {
      console.error('Cloudinary Hatası:', error.message, error.response?.data);
      if (error.code === 'ECONNABORTED') {
        setHata('İstek zaman aşımına uğradı. Lütfen tekrar deneyin.');
      } else if (error.response) {
        setHata(`Yükleme Hatası: ${error.response.data?.message || error.message}`);
      } else {
        setHata('Ağ hatası: Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin.');
      }
      setBasari('');
    } finally {
      setYukleniyor(false);
    }
  };

  const generateCanonicalUrl = (title) => {
    return title
      .toLowerCase()
      .replace(/ç/g, 'c')
      .replace(/ğ/g, 'g')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ş/g, 's')
      .replace(/ü/g, 'u')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .trim('-');
  };

  const generateKeywords = (title, content) => {
    const text = `${title} ${content.replace(/<[^>]+>/g, ' ')}`;
    const words = text.toLowerCase().split(/\s+/).filter(word => word.length > 3);
    const keywordCount = {};
    words.forEach(word => {
      keywordCount[word] = (keywordCount[word] || 0) + 1;
    });
    return Object.entries(keywordCount)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 10)
      .map(([word]) => word)
      .join(', ');
  };

  const generateStructuredData = (title, description, content, imageUrl) => {
    return JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: title,
      description: description,
      articleBody: content.replace(/<[^>]+>/g, ' '),
      datePublished: new Date().toISOString(),
      image: imageUrl,
      author: { '@type': 'Person', name: 'Yazar Adı' },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!baslik || !aciklama || !icerik || !kategori || !gorselUrl) {
      setHata('Lütfen tüm alanları doldurun ve bir görsel yükleyin.');
      return;
    }
  
    const canonicalUrl = generateCanonicalUrl(baslik);
    const keywords = generateKeywords(baslik, icerik);
    const structuredData = generateStructuredData(baslik, aciklama, icerik, gorselUrl);
  
    try {
      await addDoc(collection(db, 'blogs'), {
        title: baslik,
        description: aciklama,
        content: icerik,
        category: kategori,
        image: gorselUrl,
        createdAt: serverTimestamp(), // Firestore timestamp olarak kaydeder
        canonicalUrl: canonicalUrl,
        keywords: keywords,
        structuredData: structuredData,
      });
      setBasari('Blog başarıyla eklendi!');
      setBaslik('');
      setAciklama('');
      setIcerik('');
      setKategori('Yabancı Dil');
      setGorsel(null);
      setGorselUrl('');
      setHata('');
    } catch (error) {
      setHata('Blog eklenirken bir hata oluştu: ' + error.message);
      setBasari('');
    }
  };

  return (
    <div className="container-fluid">
      <h1 className="h3 mb-4 text-gray-800">Blog Ekle</h1>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">Yeni Blog Yazısı Ekle</h6>
        </div>
        <div className="card-body">
          {hata && <div className="alert alert-danger">{hata}</div>}
          {basari && <div className="alert alert-success">{basari}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="baslik">Başlık</label>
              <input
                type="text"
                className="form-control"
                id="baslik"
                value={baslik}
                onChange={(e) => setBaslik(e.target.value)}
                placeholder="Blog başlığını girin"
              />
            </div>
            <div className="form-group">
              <label htmlFor="aciklama">Açıklama</label>
              <textarea
                className="form-control"
                id="aciklama"
                value={aciklama}
                onChange={(e) => setAciklama(e.target.value)}
                placeholder="Blog açıklamasını girin"
                rows="3"
              />
            </div>
            <div className="form-group">
              <label htmlFor="icerik">İçerik</label>
              <ReactQuill
                theme="snow"
                value={icerik}
                onChange={setIcerik}
                modules={modules}
                placeholder="Blog içeriğini buraya yazın..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="kategori">Kategori</label>
              <select
                className="form-control"
                id="kategori"
                value={kategori}
                onChange={(e) => setKategori(e.target.value)}
              >
                {kategoriler.map((kat, index) => (
                  <option key={index} value={kat}>
                    {kat}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="gorsel">Görsel Yükle (Cloudinary)</label>
              <input
                type="file"
                className="form-control-file"
                id="gorsel"
                accept="image/*"
                onChange={handleImageUpload}
              />
              {yukleniyor && <p>Görsel yükleniyor...</p>}
              {gorselUrl && (
                <div className="mt-2">
                  <img src={gorselUrl} alt="Yüklenen görsel" style={{ maxWidth: '200px' }} />
                </div>
              )}
            </div>
            <button type="submit" className="btn btn-primary" disabled={yukleniyor}>
              Blog Ekle
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BlogEkle;